import { el } from '@/lib/dom'

/**
 * UŞAQ PROFİLİNİN ORTAQ DİZAYN DATASI — «Nə baxaq?» janrları və sıra rəngləri.
 *
 * ⚠⚠ NİYƏ AYRICA MODUL (2026-08-30): NƏ ÖLÇÜLDÜ — tv.kinobox.az-da uşaq profili
 *    («Ləman», isKids=true, maxAgeRating=12) seçilib səhifə yeniləndi və səhnədə
 *    ADİ ana ekran çəkildi (ilk uşaq düyünü `web-page`, adi hero, «Sənin üçün /
 *    Yeni filmlər / …» sıraları, 163 `.web-card`; `/Salam|Nə baxaq/` naxışı
 *    səhnə mətnində TAPILMADI). ƏVVƏL NƏ OLURDU: uşaq ekranı YALNIZ cihaz giriş
 *    nöqtəsinə bağlı idi (`src/main.ts` → `isKidsProfile() ? createKidsHomeScreen`),
 *    `src/browser/main.ts` → `homeScreen()` isə həmişə `createWebHomeScreen`
 *    çağırırdı və `src/browser/` altında «kids» sözü ÜMUMİYYƏTLƏ yox idi.
 *    NİYƏ MƏHZ BU HƏLL: cihaz ekranı (`screens/kidsHome.ts`) OLDUĞU KİMİ yenidən
 *    işlədilə bilmir — o, `FocusGrid` + sabit piksel arifmetikası (`GREETING_HEIGHT`,
 *    `ROW_HEIGHT`, `CARD_PITCH`) ilə 1920×1080 kətan üçün yazılıb, brauzer variantı
 *    isə məhz o mühərriki İŞLƏTMİR (`browser/main.ts` başlığı: «`lib/focus.ts`
 *    şəbəkəsi … sabit 1920×1080 kətan üçün yazılıb və bu variantda mənasızdır»).
 *    Ona görə maket iki dəfə qurulur, DATA isə burada BİR dəfə — janr siyahısı,
 *    ikon yolu və rəng dövrü iki səthdə ayrılmasın deyə.
 */

/**
 * SIRA RƏNGLƏRİ — altı aksent sıra ilə, altıncıdan sonra dövr yenidən başlayır.
 *
 * ⚠ DƏYƏR CSS-DƏDİR, BURADA YALNIZ AD: `tv.css` → `.kidsrow--*` / `.kidstitle--*`.
 * ⚠ ARDICILLIQ sayt/iOS/Android `KidsPalette.cycle` ilə EYNİDİR — bir bölmə bütün
 *   səthlərdə eyni rəngdədir.
 */
export const KIDS_ROW_TONES = ['animation', 'adventure', 'comedy', 'historical', 'sport', 'documentary']

export interface KidsCategory {
  slug: string
  title: string
  icon: string
}

/**
 * «Nə baxaq?» kartları.
 *
 * ⚠⚠ JANR SEÇİMİ ƏLLƏDİR, KATALOQDAN GƏLDİYİ KİMİ YOX: `/api/catalog/genres` uşaq
 *    həddi ilə çağırılanda da «Dəhşət», «Cinayət», «Triller» qaytarır — ÖLÇÜLDÜ
 *    (2026-08-26, canlı: `?maxAge=12` → horror 2, crime 1, thriller 2). Səbəb odur ki,
 *    həmin filmlərin `age_limit`-i 12-dir, yəni yaş qaydası onları buraxır. Uşağın ANA
 *    EKRANINDA «Dəhşət» kartı göstərmək isə yaş qaydasından ayrı bir məsələdir.
 * ⚠ SİYAHI SABİTDİR, «kataloqda varmı» YOXLANILMIR: ekran SİNXRON qurulur — janr
 *   sorğusunu gözləmək ekranın açılmasını gecikdirərdi. Boş janrda siyahı ekranı öz
 *   «nəticə yoxdur» vəziyyətini göstərir, qara ekran olmur.
 * ⚠ iOS/Android `KidsCategory` ilə EYNİ altı janr.
 */
export const KIDS_CATEGORIES: KidsCategory[] = [
  { slug: 'animation', title: 'Cizgi filmləri', icon: 'M12 3l1.9 4.6 5 .4-3.8 3.3 1.2 4.9L12 13.6 7.7 16.2l1.2-4.9L5.1 8l5-.4z' },
  { slug: 'adventure', title: 'Macəra', icon: 'M9 4L3 6v14l6-2 6 2 6-2V4l-6 2-6-2zm0 2.2l6 2v11.6l-6-2V6.2z' },
  { slug: 'comedy', title: 'Komediya', icon: 'M12 2a10 10 0 100 20 10 10 0 000-20zM8 9a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm5 0a1.5 1.5 0 113 0 1.5 1.5 0 01-3 0zm-5.2 4.5h8.4a4.4 4.4 0 01-8.4 0z' },
  { slug: 'historical', title: 'Tarixi', icon: 'M12 3L2 8v2h20V8L12 3zM4 11v7H2v2h20v-2h-2v-7h-2v7h-3v-7h-2v7h-2v-7H9v7H6v-7H4z' },
  { slug: 'sport', title: 'İdman', icon: 'M13.5 5.5a2 2 0 100-4 2 2 0 000 4zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3A7 7 0 0019 13v-2a5 5 0 01-4.2-2.4l-1-1.6c-.4-.6-1-1-1.8-1-.3 0-.6.1-.8.2L6 7.2V11h2V8.6l1.8-.7z' },
  { slug: 'documentary', title: 'Sənədli', icon: 'M4 4h7a3 3 0 013 3v13a3 3 0 00-3-3H4V4zm16 0h-7a3 3 0 00-3 3v13a3 3 0 013-3h7V4z' },
]

/** SVG ikon — `innerHTML` ilə (ES2015 həddi: şablon sətri var, `??`/`?.` yoxdur). */
export function kidsCategoryIcon(path: string): HTMLElement {
  const box = el('div', 'kidscat__icon')
  box.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + path + '"></path></svg>'
  return box
}
